module.exports = {
  'en': {
    '10': 'Login',
    '15': 'Login - Train',
    '20': 'Username',
    '30': 'Password',
    '40': 'Language',
    '50': 'Forgot Password',
    '60': 'Change Password',
    '70': 'Email',
    '80': 'Current Password',
    '90': 'New Password',
    '100': 'Confirm Password',
    '110': 'Cancel',
    '120': 'Submit',
    '130': 'OK',
    '140': 'ID Card No.',
    '150': 'OTP Code Number',
    '160': 'ระบบได้ส่ง รหัส OTP Code ไปที่อีเมลของคุณ กรุณากรอก รหัส OTP Code เพื่อยืนยันการทำรายการ'
  },
  'th': {
    '10': 'เข้าสู่ระบบ',
    '15': 'เข้าสู่ระบบ - Train',
    '20': 'ผู้ใช้งาน',
    '30': 'รหัสผ่าน',
    '40': 'ภาษา',
    '50': 'ลืมรหัสผ่าน',
    '60': 'เปลี่ยนรหัสผ่าน',
    '70': 'อีเมล',
    '80': 'รหัสผ่านปัจจุบัน',
    '90': 'รหัสผ่านใหม่',
    '100': 'ยืนยันรหัสผ่านใหม่',
    '110': 'ยกเลิก',
    '120': 'ยืนยัน',
    '130': 'ตกลง',
    '140': 'เลขประจำตัวประชาชน',
    '150': 'รหัส OTP',
    '160': 'ระบบได้ส่ง รหัส OTP Code ไปที่อีเมลของคุณ กรุณากรอก รหัส OTP Code เพื่อยืนยันการทำรายการ'
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/login.js